var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1066 44.2665H21.9927V41.7155C21.9927 40.2205 20.7808 39.008 19.2843 39.008H7.50242C6.00663 39.008 4.79396 40.2205 4.79396 41.7155V44.2665H3.68014C2.18516 44.2665 0.97168 45.4791 0.97168 46.9757V50H25.815V46.9757C25.815 45.4791 24.6032 44.2665 23.1066 44.2665Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4018 32.9162L31.9704 19.8393L33.001 18.3076C33.8088 17.1072 33.9467 15.6532 33.5004 14.3866C35.1921 12.0626 36.6838 13.7445 37.8384 11.5477C39.0225 9.29453 37.5741 7.22833 31.9899 3.47059C26.4059 -0.287353 23.9464 -0.851267 22.3061 1.09417C20.7531 2.93438 22.701 3.69486 21.4354 5.96746C19.9396 5.88679 18.4397 6.57228 17.5429 7.90479L11.4047 17.0264C10.5176 18.3444 10.4385 19.9682 11.0537 21.3146C9.52285 22.9271 8.17156 21.6542 7.10574 23.6812C5.9225 25.9334 7.37019 27.9996 12.9542 31.7575C18.5384 35.5154 20.9979 36.0784 22.6389 34.1338C24.1674 32.3214 22.3027 31.5584 23.4518 29.3657C24.781 29.2931 26.0622 28.619 26.8627 27.4292L28.1113 25.5744L47.5419 38.6514C49.1258 39.7171 51.2737 39.2969 52.3394 37.7137C53.4052 36.1299 52.985 33.9821 51.4018 32.9162Z",
    fill: "#6C84F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.7bc81de497813404c90faecb02b32b72.svg";
export { ForwardRef as ReactComponent };